import { QueryClient } from '@tanstack/react-query';
import { downloadFile } from '../api/file-upload.service';

export const prefetchAvatar = async (
  queryClient: QueryClient,
  fileId: number | null | undefined
) => {
  if (!fileId) return;

  try {
    await queryClient.prefetchQuery({
      queryKey: ['file-download', fileId],
      queryFn: () => downloadFile(fileId),
      staleTime: 10 * 60 * 1000, // 10 minutes
    });
  } catch (error) {
    console.debug('Avatar prefetch failed:', error);
  }
};
